<template>
  <div>
    <b-loading :is-full-page="true" :active="!initialized"></b-loading>
    <section v-if="initialized" class="section is-main-section">
      <EventHeader :event="event" />
      <div class="section">
        <div class="columns is-centered">
          <div class="column is-4 is-primary has-text-centered">
            <CardComponent>
              <h3 class="title is-5">Total Registrations</h3>
              <h3 class="title is-1">
                <GrowingNumber :duration="5000" :value="entries.length" />
              </h3>
              <router-link
                :to="{
                  name: 'ManageRegistrations',
                  params: { eventid: this.event._id },
                }"
              >
                <span>View Entries</span>
              </router-link>
            </CardComponent>
          </div>
          <!-- <div class="column is-4 is-primary has-text-centered">
            <CardComponent>
              <h3 class="title is-5">Paid Entries Total</h3>
              <h3 class="title is-1">
                <GrowingNumber :duration="5000" :value="paidEntryFees" />
              </h3>
            </CardComponent>
          </div> -->
          <div
            v-if="
              event.entrytypes.includes('Individual') &&
              event.entrytypes.includes('Team')
            "
            class="column is-4 is-primary has-text-centered"
          >
            <CardComponent>
              <h3 class="title is-5">Individual Entries</h3>
              <h3 class="title is-1">
                <GrowingNumber
                  v-if="entries.length > 0"
                  :duration="5000"
                  :value="
                    entries.filter((item) => item.entrytype === 'Individual')
                      .length
                  "
                />
              </h3>
            </CardComponent>
          </div>
          <div
            v-if="
              event.entrytypes.includes('Team') &&
              event.entrytypes.includes('Individual')
            "
            class="column is-4 is-primary has-text-centered"
          >
            <CardComponent>
              <h3 class="title is-5">Team Entries</h3>
              <h3 class="title is-1">
                <GrowingNumber
                  v-if="entries.length > 0"
                  :duration="5000"
                  :value="
                    entries.filter((item) => item.entrytype === 'Team').length
                  "
                />
              </h3>
            </CardComponent>
          </div>
        </div>
        <div class="columns is-multiline">
          <div class="column is-4">
            <CardComponent title="Paid">
              <div v-if="paidChart.chartData" class="chart-area">
                <DoughnutChart
                  ref="paidChart"
                  style="height: 100%"
                  chart-id="paid-chart"
                  :chart-data="paidChart.chartData"
                  :extra-options="paidChart.extraOptions"
                >
                </DoughnutChart>
              </div>
            </CardComponent>
          </div>
          <div class="column is-4">
            <CardComponent title="Category Split">
              <div v-if="paidChart.chartData" class="chart-area">
                <DoughnutChart
                  ref="categorySplitChart"
                  style="height: 100%"
                  chart-id="category-split-chart"
                  :chart-data="categorySplitChart.chartData"
                  :extra-options="categorySplitChart.extraOptions"
                >
                </DoughnutChart>
              </div>
            </CardComponent>
          </div>
          <div
            v-if="event.entrytypes.includes('Individual')"
            class="column is-4"
          >
            <CardComponent title="Individuals Split">
              <div v-if="individualsSplitChart.chartData" class="chart-area">
                <DoughnutChart
                  ref="individualsSplitChart"
                  style="height: 100%"
                  chart-id="individuals-split-chart"
                  :chart-data="individualsSplitChart.chartData"
                  :extra-options="individualsSplitChart.extraOptions"
                >
                </DoughnutChart>
              </div>
            </CardComponent>
          </div>
          <div class="column is-4">
            <CardComponent title="Top 10 Gym Split">
              <div v-if="gymSplitChart.chartData" class="chart-area">
                <BarChart
                  ref="gymSplitChart"
                  style="height: 100%"
                  chart-id="gym-split-chart"
                  :chart-data="gymSplitChart.chartData"
                  :extra-options="gymSplitChart.extraOptions"
                >
                </BarChart>
              </div>
            </CardComponent>
          </div>
          <div class="column is-4">
            <CardComponent title="No of Entries in last 30 days">
              <div v-if="daysSplitChart.chartData" class="chart-area">
                <BarChart
                  ref="daysSplitChart"
                  style="height: 100%"
                  chart-id="day-split-chart"
                  :chart-data="daysSplitChart.chartData"
                  :extra-options="daysSplitChart.extraOptions"
                >
                </BarChart>
              </div>
            </CardComponent>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GrowingNumber from '@/components/GrowingNumber'
import CardComponent from '@/components/CardComponent'
import DoughnutChart from '@/components/Charts/DoughnutChart'
import BarChart from '@/components/Charts/BarChart'
import EventHeader from '@/components/EventHeader'
import EventEntryApi from '@/api/event-entry'
import _ from 'lodash'
import { format, differenceInDays } from 'date-fns'

export default {
  name: 'EventDashboard',
  components: {
    CardComponent,
    GrowingNumber,
    DoughnutChart,
    EventHeader,
    BarChart,
  },
  data() {
    return {
      initialized: false,
      entries: [],
      paidChart: {},
      categorySplitChart: {},
      gymSplitChart: {},
      individualentries: 0,
      teamentries: 0,
      paidEntryFees: 0,
      individualsSplitChart: {},
      daysSplitChart: {},
    }
  },
  computed: {
    ...mapGetters(['event']),
  },
  async created() {
    this.entries = await EventEntryApi.entriesForEvent(
      this.$route.params.eventid
    )

    this.paidEntryFees = _.sumBy(this.entries, 'entryfee')

    let paid = this.entries.filter((item) => item.paid).length
    this.paidChart.chartData = {
      datasets: [
        {
          backgroundColor: ['#56c4c6', '#eee'],
          data: [paid, this.entries.length - paid],
        },
      ],
      labels: ['Paid', 'Not Paid'],
    }

    let categorySplit = _(this.entries)
      .groupBy((item) => {
        return item.category
      })
      .map(function (items, category) {
        return { category: category, count: items.length }
      })
      .value()

    this.categorySplitChart.chartData = {
      datasets: [
        {
          backgroundColor: [
            '#56c4c6',
            '#eee',
            '#000',
            '#fee',
            '#999',
            '#222',
            '#666',
            '#efefef',
          ],
          data: categorySplit.map((item) => item.count),
        },
      ],
      labels: categorySplit.map((item) => item.category),
    }

    let gymSplit = _(this.entries)
      .filter((item) => item.gymname)
      .groupBy((item) => {
        return item.gymname
      })
      .map((items, gymname) => {
        return { gymname: gymname, count: items.length }
      })
      .sortBy('count')
      .reverse()
      .take(10)
      .value()

    this.gymSplitChart.chartData = {
      datasets: [
        {
          label: 'Gym Name',
          backgroundColor: '#56c4c6',
          data: gymSplit.map((item) => item.count),
        },
      ],
      labels: gymSplit.map((item) => item.gymname),
    }

    let individualsSplit = _(this.entries)
      .filter((item) => item.entrytype === 'Individual' && item.user?.gender)
      .groupBy((item) => {
        return item.user.gender
      })
      .map(function (items, gender) {
        return { gender: gender, count: items.length }
      })
      .value()

    this.individualsSplitChart.chartData = {
      datasets: [
        {
          backgroundColor: ['#56c4c6', '#eee'],
          data: individualsSplit.map((item) => item.count),
        },
      ],
      labels: individualsSplit.map((item) => item.gender),
    }

    let now = Date.now()
    let daySplit = _(this.entries)
      .filter((item) => differenceInDays(new Date(item.datecreated), now) <= 30)
      .groupBy((item) => {
        return format(new Date(item.datecreated), 'dd MMM yyyy')
      })
      .map(function (items, date) {
        return { date: date, count: items.length }
      })
      .value()

    this.daysSplitChart.chartData = {
      datasets: [
        {
          label: 'Date',
          backgroundColor: '#56c4c6',
          data: daySplit.map((item) => item.count),
        },
      ],
      labels: daySplit.map((item) => item.date),
    }

    this.initialized = true
  },
  methods: {},
}
</script>

<style>
</style>
